import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$5 = "/**\n * Animation tokens\n *\n * These are the values that express the animations of\n * the design system.\n */\n/**\n * Color tokens\n *\n * These are the values that express the colors of the design system.\n */\n/**\n * Font tokens\n *\n * These are the values that express the atomic units\n * of the design system.\n */\n/**\n * Layout tokens\n *\n * These are the values that express the spatial dimensions of\n * the design system.\n */\n.Button {\n  padding: 10px;\n  color: #FFFFFF;\n  font-size: 1.125rem;\n  font-weight: 500;\n  background: #6666FF;\n  border: 0;\n  border-radius: 10px;\n  box-shadow: 0 0 5px 0 rgba(5, 0, 56, 0.4);\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.Button:hover {\n  background: #5555C8;\n}\n.Button.secondary {\n  color: #6666FF;\n  background: #EDEBFF;\n}\n.Button.secondary:hover {\n  background: #e4e4ea;\n}\n.Button.secondary svg {\n  stroke: #6666FF;\n}\n.Button[disabled] {\n  opacity: 0.5;\n  pointer-events: none !important;\n}\n.Button + .Button {\n  margin-left: 15px;\n}\n.Button svg {\n  stroke: #FFFFFF;\n}";
styleInject(css_248z$5);

function Button(_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, props = __rest$1(_a, ["children", "className", "disabled"]);
    return (jsx("button", __assign$1({ className: "Button ".concat(className || ''), disabled: disabled }, props, { children: children })));
}

var css_248z$4 = "/**\n * Color tokens\n *\n * These are the values that express the colors of the design system.\n */\n/**\n * Font tokens\n *\n * These are the values that express the atomic units\n * of the design system.\n */\n.Checkbox {\n  display: inline-flex;\n  width: 1rem;\n  height: 1rem;\n  background: rgba(102, 102, 255, 0.5);\n  border: 1px solid #6666FF;\n  border-radius: 50%;\n  overflow: hidden;\n}\n.Checkbox svg {\n  opacity: 0;\n  width: 100%;\n  stroke: #FFFFFF;\n  top: -3px;\n  left: 0;\n  right: 0;\n  display: inline-flex;\n  position: absolute;\n  transition: top 0.15s, opacity 0.15s;\n  pointer-events: none;\n}\n.Checkbox.checked {\n  background: #6666ff;\n}\n.Checkbox.checked svg {\n  top: 0;\n  opacity: 1;\n}";
styleInject(css_248z$4);

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React.createContext && React.createContext(DefaultContext);

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return React.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return React.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return React.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? React.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

// THIS FILE IS AUTO GENERATED
function FiCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"polyline","attr":{"points":"20 6 9 17 4 12"}}]})(props);
}function FiChevronLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"polyline","attr":{"points":"15 18 9 12 15 6"}}]})(props);
}

function Checkbox(_a) {
    var onClick = _a.onClick, value = _a.value;
    return (jsx("button", __assign$1({ className: 'Checkbox' + (value ? ' checked' : ''), onClick: function () { return onClick(); } }, { children: jsx(FiCheck, {}) })));
}

var css_248z$3 = "/**\n * Animation tokens\n *\n * These are the values that express the animations of\n * the design system.\n */\n/**\n * Color tokens\n *\n * These are the values that express the colors of the design system.\n */\n/**\n * Layout tokens\n *\n * These are the values that express the spatial dimensions of\n * the design system.\n */\n.IconButton {\n  width: 2.8571rem;\n  height: 2.8571rem;\n  padding: 8px;\n  background: #FFFFFF;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.IconButton:hover, .IconButton.active {\n  background: #F2F5FA;\n}\n.IconButton:hover > *, .IconButton:hover svg, .IconButton.active > *, .IconButton.active svg {\n  color: #6666FF;\n}\n.IconButton.active:hover {\n  background: #e0e7f3;\n}\n.IconButton * {\n  pointer-events: none !important;\n}\n.IconButton > *, .IconButton svg {\n  display: block;\n  height: 100%;\n  width: 100%;\n  color: #050038;\n  transition: color 0.15s;\n}\n.IconButton[disabled] {\n  opacity: 0.5;\n  pointer-events: none !important;\n}";
styleInject(css_248z$3);

function IconButton(_a) {
    var active = _a.active, children = _a.children, className = _a.className, disabled = _a.disabled, props = __rest$1(_a, ["active", "children", "className", "disabled"]);
    return (jsx("button", __assign$1({ className: "IconButton ".concat(className || '', " ").concat(active ? 'active' : ''), disabled: disabled }, props, { children: children })));
}

/**
 * Utilities
 */
function noop() { }

var Portal = createContext({});
function usePortal() {
    return useContext(Portal);
}
function usePortals() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var refs = args.reduce(function (refs, portal) {
        refs[portal] = null;
        return refs;
    }, {});
    var _a = useState(refs), portals = _a[0], setPortals = _a[1];
    var setPortal = useCallback(function (name, el) {
        var _a;
        if (el !== null && (portals[name] === null
            || el.outerHTML !== portals[name].outerHTML)) {
            setPortals(__assign$1(__assign$1({}, portals), (_a = {}, _a[name] = el, _a)));
        }
    }, [portals]);
    return [portals, setPortal];
}

var css_248z$2 = "/**\n * Animation tokens\n *\n * These are the values that express the animations of\n * the design system.\n */\n/**\n * Color tokens\n *\n * These are the values that express the colors of the design system.\n */\n/**\n * Font tokens\n *\n * These are the values that express the atomic units\n * of the design system.\n */\n/**\n * Layout tokens\n *\n * These are the values that express the spatial dimensions of\n * the design system.\n */\n.Modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2147483647;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.25s;\n}\n.Modal * {\n  pointer-events: none;\n}\n.Modal.active {\n  opacity: 1;\n  pointer-events: all;\n}\n.Modal.active * {\n  pointer-events: all;\n}\n.Modal--gutter {\n  position: absolute;\n  top: 0;\n  left: 0;\n  flex: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n.Modal--window {\n  flex: 0 1 min-content;\n  max-height: 100vh;\n  min-width: 800px;\n  margin: auto;\n  background: #FFFFFF;\n  border-radius: 10px;\n  box-shadow: 0 0 5px 0 rgba(5, 0, 56, 0.4);\n  overflow: hidden;\n}\n.Modal header {\n  padding: 15px;\n  background: #F2F5FA;\n}\n.Modal header h2 {\n  margin: 0;\n  color: #6666FF;\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n.Modal header p {\n  margin: 10px 0 0;\n  color: #7D7A96;\n  font-size: 0.75rem;\n  line-height: 1.5em;\n}\n.Modal header p em {\n  font-style: normal;\n  color: #6666FF;\n}\n.Modal main {\n  max-height: 70vh;\n  padding: 30px 60px 15px 60px;\n  overflow-y: auto;\n}\n.Modal footer {\n  padding: 15px;\n  text-align: right;\n}";
styleInject(css_248z$2);

function Modal(_a) {
    var active = _a.active, children = _a.children, className = _a.className, mount = _a.mount, onClose = _a.onClose, style = _a.style;
    var _b = useState(active), visible = _b[0], setVisible = _b[1];
    var _c = usePortals('Title', 'SubTitle', 'Body', 'Buttons'), portals = _c[0], setPortal = _c[1];
    useEffect(function () {
        if (active) {
            setVisible(true);
        }
        else {
            setTimeout(function () { return !active && setVisible(false); }, 250);
        }
    }, [active]);
    return createPortal(jsxs("div", __assign$1({ className: "Modal ".concat(className || '', " ").concat(active ? 'active' : ''), style: style }, { children: [jsx("div", { className: "Modal--gutter", onClick: onClose || noop }), jsx("div", __assign$1({ className: "Modal--window" }, { children: jsxs(Portal.Provider, __assign$1({ value: portals }, { children: [visible && jsxs(Fragment, { children: [jsxs("header", { children: [jsx("h2", { ref: function (el) { return setPortal('Title', el); } }), jsx("p", { ref: function (el) { return setPortal('SubTitle', el); } })] }), jsx("main", { ref: function (el) { return setPortal('Body', el); } }), jsx("footer", { ref: function (el) { return setPortal('Buttons', el); } })] }), children] })) }))] })), mount || document.querySelector('body'));
}

var css_248z$1 = "/**\n * Animation tokens\n *\n * These are the values that express the animations of\n * the design system.\n */\n/**\n * Color tokens\n *\n * These are the values that express the colors of the design system.\n */\n/**\n * Font tokens\n *\n * These are the values that express the atomic units\n * of the design system.\n */\n/**\n * Layout tokens\n *\n * These are the values that express the spatial dimensions of\n * the design system.\n */\n.Panel {\n  display: flex;\n  flex-direction: column;\n  background: #FFFFFF;\n  border-radius: 5px;\n  box-shadow: 0 0 5px 0 rgba(5, 0, 56, 0.4);\n  overflow: hidden;\n}\n.Panel:not(.active) {\n  width: 2.8571rem;\n  height: 2.8571rem;\n}\n.Panel:not(.active) h2,\n.Panel:not(.active) main,\n.Panel:not(.active) .Panel--header__right {\n  display: none;\n}\n.Panel header {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #7D7A96;\n}\n.Panel--header__left {\n  display: flex;\n  align-items: center;\n  flex: 0 1 max-content;\n}\n.Panel--header__left .IconButton {\n  border-bottom-left-radius: 0px;\n}\n.Panel--header__right {\n  flex: 1;\n  display: flex;\n  padding-right: 1px;\n  text-align: right;\n}\n.Panel--header__right > * {\n  margin-left: auto;\n}\n.Panel--header__right > * + * {\n  margin-right: 15px;\n}\n.Panel--header__left h2, .Panel--header__right {\n  height: 2.8571rem;\n  display: flex;\n  align-items: center;\n  padding: 2px 1px;\n}\n.Panel h2 {\n  margin: 0 0 0 10px;\n  color: #050038;\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n.Panel main {\n  overflow-y: auto;\n}";
styleInject(css_248z$1);

function Panel(_a) {
    var active = _a.active, children = _a.children, className = _a.className, onToggle = _a.onToggle, style = _a.style;
    var _b = usePortals('Body', 'Title', 'Toggle', 'Header'), portals = _b[0], setPortal = _b[1];
    return (jsx("div", __assign$1({ className: "Panel ".concat(className || '', " ").concat(active ? 'active' : ''), style: style }, { children: jsxs(Portal.Provider, __assign$1({ value: portals }, { children: [jsxs("header", { children: [jsxs("div", __assign$1({ className: "Panel--header__left" }, { children: [jsx(IconButton, __assign$1({ onClick: (onToggle || noop) }, { children: jsx("span", { ref: function (el) { return setPortal('Toggle', el); } }) })), jsx("h2", { ref: function (el) { return setPortal('Title', el); } })] })), jsx("div", { className: "Panel--header__right", ref: function (el) { return setPortal('Header', el); } })] }), active && (jsx("main", { ref: function (el) { return setPortal('Body', el); } })), children] })) })));
}

var css_248z = "/**\n * Animation tokens\n *\n * These are the values that express the animations of\n * the design system.\n */\n/**\n * Color tokens\n *\n * These are the values that express the colors of the design system.\n */\n/**\n * Font tokens\n *\n * These are the values that express the atomic units\n * of the design system.\n */\n/**\n * Layout tokens\n *\n * These are the values that express the spatial dimensions of\n * the design system.\n */\n.TopRibbon {\n  display: flex;\n  align-items: center;\n  width: max-content;\n}\n.TopRibbon.closed .TopRibbon--toggle svg {\n  transform: rotate(180deg);\n}\n.TopRibbon--title {\n  display: flex;\n  flex: 1 0 max-content;\n  padding: 10px;\n  background: #050038;\n  border-radius: 5px;\n  box-shadow: 0 0 5px 0 rgba(5, 0, 56, 0.4);\n  overflow: hidden;\n}\n.TopRibbon--title h1 {\n  margin: auto;\n  margin-left: 20px;\n  color: #FFFFFF;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n.TopRibbon--title img {\n  height: calc(3.5714rem - 20px);\n}\n.TopRibbon--slot {\n  border-radius: 0 5px 5px 0;\n  box-shadow: 0 0 5px 0 rgba(5, 0, 56, 0.4);\n  overflow: hidden;\n}\n.TopRibbon--ribbon {\n  display: flex;\n  margin-left: 0;\n  height: min-content;\n  width: max-content;\n  background: #FFFFFF;\n  transition: margin-left 0.25s;\n}\n.TopRibbon--ribbon-drawer, .TopRibbon--ribbon-body {\n  display: flex;\n  align-items: center;\n}";
styleInject(css_248z);

function TopRibbon(_a) {
    var children = _a.children, className = _a.className, style = _a.style;
    var _b = usePortals('Logo', 'Title', 'Body', 'Drawer'), portals = _b[0], setPortal = _b[1];
    var _c = useState(false), closed = _c[0], setClosed = _c[1];
    var _d = useState(0), drawerWidth = _d[0], setDrawerWidth = _d[1];
    useEffect(function () {
        if (portals.Drawer) {
            var onResize = function () {
                setDrawerWidth(portals.Drawer.getBoundingClientRect().width);
            };
            onResize();
            return new ResizeObserver(onResize).observe(portals.Drawer);
        }
    }, [portals.Drawer]);
    return (jsx("div", __assign$1({ className: "TopRibbon ".concat(className || '', " ").concat(closed ? 'closed' : ''), style: style }, { children: jsxs(Portal.Provider, __assign$1({ value: portals }, { children: [jsxs("div", __assign$1({ className: "TopRibbon--title" }, { children: [jsx("div", { ref: function (el) { return setPortal('Logo', el); } }), jsx("h1", { ref: function (el) { return setPortal('Title', el); } })] })), jsx("div", __assign$1({ className: "TopRibbon--slot" }, { children: jsxs("div", __assign$1({ className: "TopRibbon--ribbon", style: closed ? ({ marginLeft: "-".concat(drawerWidth, "px") }) : {} }, { children: [jsx("div", { className: "TopRibbon--ribbon-drawer", ref: function (el) { return setPortal('Drawer', el); } }), jsx("div", { className: "TopRibbon--ribbon-body", ref: function (el) { return setPortal('Body', el); } }), jsx(IconButton, __assign$1({ className: "TopRibbon--toggle", onClick: function () { return setClosed(!closed); } }, { children: jsx(FiChevronLeft, {}) }))] })) })), children] })) })));
}

function Body(_a) {
    var children = _a.children;
    var portal = usePortal();
    if (portal.Body) {
        return createPortal(children, portal.Body);
    }
    return jsx(Fragment, {});
}

function Buttons(_a) {
    var children = _a.children;
    var portal = usePortal();
    if (portal.Buttons) {
        return createPortal(children, portal.Buttons);
    }
    return jsx(Fragment, {});
}

function Drawer(_a) {
    var children = _a.children;
    var portal = usePortal();
    if (portal.Drawer) {
        return createPortal(children, portal.Drawer);
    }
    return jsx(Fragment, {});
}

function Header(_a) {
    var children = _a.children;
    var portal = usePortal();
    if (portal.Header) {
        return createPortal(children, portal.Header);
    }
    return jsx(Fragment, {});
}

function Logo(_a) {
    var children = _a.children;
    var portal = usePortal();
    if (portal.Logo) {
        return createPortal(children, portal.Logo);
    }
    return jsx(Fragment, {});
}

function SubTitle(_a) {
    var children = _a.children;
    var portal = usePortal();
    if (portal.SubTitle) {
        return createPortal(children, portal.SubTitle);
    }
    return jsx(Fragment, {});
}

function Title(_a) {
    var children = _a.children;
    var portal = usePortal();
    if (portal.Title) {
        return createPortal(children, portal.Title);
    }
    return jsx(Fragment, {});
}

function Toggle(_a) {
    var children = _a.children;
    var portal = usePortal();
    if (portal.Toggle) {
        return createPortal(children, portal.Toggle);
    }
    return jsx(Fragment, {});
}

export { Body, Button, Buttons, Checkbox, Drawer, Header, IconButton, Logo, Modal, Panel, SubTitle, Title, Toggle, TopRibbon };
//# sourceMappingURL=index.es.js.map
